import 'ui-core/plugins/slide/js/slide';

var isTablet = true;

UX.slide.additionalResponsive = function () {
    $(document).on('screen-xs-on', function () {
        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
        isTablet = false;
        UX.slide.backIcon = 'icon-arrow_l';
    });

    $(document).on('screen-xs-off', function () {
        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
        isTablet = true;
        UX.slide.backIcon = 'icon-close_thin';
    });
};

UX.slide.on._showSlide = function () {
    if (isTablet) {
        if (!UX.slide.nested) {
            UX.slide.$elements.addClass('js--open');
        } else {
            UX.slide.$contents.addClass('js--open');
        }
    } else {
        const slideWidth = '100%';

        let $slidedDiv = UX.slide.$elements;
        if (UX.slide.nested || UX.slide.multi) {
            $slidedDiv = UX.slide.$contents;
        }

        if (!UX.slide.$elements.hasClass('js--open') && UX.slide.multi) {
            $slidedDiv = $('[class*=nested--], .w-slide');
        }

        $slidedDiv
            .css('transform', 'translateX(-' + slideWidth + ')')
            .off()
            .one('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
                e.stopPropagation();
                UX.slide.isQueue = false;
                UX.slide.removeTransition();
            });
        UX.slide.$elements.addClass('js--open');
        UX.slide.on.additionalShowSlide();
    }
    UX.slide.$slideinfo.show().addClass('js--open');
};
UX.slide.on._hideSlide = function () {
    let updateTarget;
    if (!UX.slide.nested) updateTarget = UX.slide.$elements;
    else updateTarget = UX.slide.$contents;

    if (isTablet) {
        updateTarget.removeClass('js--open');
    } else {
        updateTarget.css('transform', 'translateX(0vw)');
    }

    updateTarget.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
        if (UX.slide.back) $(this).removeAttr('style');
        if (!UX.slide.nested) UX.slide.$contents.empty();
        else if (UX.slide.nested) $(this).remove();
        UX.slide.$elements.off();
    });
};

UX.slide.backLabel = '';
UX.slide.backIcon = 'icon-close_thin';
UX.slide.setBackLabel = function () {
    UX.slide.$back.html('<i class="' + UX.slide.backIcon + '" aria-hidden="true"></i>');
};
